import { render, staticRenderFns } from "./activeManager.vue?vue&type=template&id=a50cbadc&scoped=true"
import script from "./activeManager.vue?vue&type=script&lang=js"
export * from "./activeManager.vue?vue&type=script&lang=js"
import style0 from "./activeManager.vue?vue&type=style&index=0&id=a50cbadc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50cbadc",
  null
  
)

export default component.exports